import { useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import ProductCard from "@/components/ProductCard";
import { useLang } from "@/lib/i18n";

export default function Search() {
  const [sp] = useSearchParams();
  const { t } = useLang();
  const [products, setProducts] = useState([]);
  const [services, setServices] = useState([]);
  const q = sp.get("q") || "";
  const category_id = sp.get("category_id");
  const kind = sp.get("kind");

  useEffect(() => {
    const params = new URLSearchParams();
    if (q) params.set("q", q);
    if (category_id) params.set("category_id", category_id);
    if (kind !== "service") api.get(`/products?${params}`).then((r) => setProducts(r.data));
    else setProducts([]);
    if (kind !== "product") api.get(`/services?${params}`).then((r) => setServices(r.data));
    else setServices([]);
  }, [q, category_id, kind]);

  return (
    <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-12" data-testid="search-page">
      <p className="label-uppercase text-xs text-[#C85A32]">{t("footer.search")}</p>
      <h1 className="heading font-extrabold text-4xl mt-2 mb-8">{q ? `« ${q} »` : t("search.title")}</h1>

      {products.length > 0 && (
        <section className="mb-12">
          <h2 className="heading font-bold text-xl mb-4">{t("header.products")} ({products.length})</h2>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6" data-testid="search-products">
            {products.map((p) => <ProductCard key={p.id} p={p} kind="product"/>)}
          </div>
        </section>
      )}

      {services.length > 0 && (
        <section>
          <h2 className="heading font-bold text-xl mb-4">{t("header.services")} ({services.length})</h2>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6" data-testid="search-services">
            {services.map((p) => <ProductCard key={p.id} p={p} kind="service"/>)}
          </div>
        </section>
      )}

      {products.length === 0 && services.length === 0 && (
        <p className="text-[#4B5563]" data-testid="search-empty">{t("search.no_results")}</p>
      )}
    </div>
  );
}
